<template>
    <div class="write">
        <van-form @submit="onSubmit" ref="form" :show-error="false">
            <van-field 
                name="name"
                v-model="formData.userMemberName"
                label="患者名称"
                placeholder="请输入患者名称"
                readonly
                :required="false"
                :rules="[{ required: false, message: '请输入患者名称' }]"
            />
            <van-field
                clickable
                readonly
                name="diseaseType"
                :value="diseaseType"
                label="疾病病种"
                placeholder="点击选择疾病病种"
                :required="false"
                :rules="[{ required: false, message: '请点击选择疾病病种' }]"
                @click="showDiseaseType = true"
            />
            <van-popup v-model="showDiseaseType" round position="bottom">
                <van-picker
                    show-toolbar
                    :columns="diseaseTypeList"
                    @cancel="showDiseaseType = false"
                    @confirm="onConfirmDiseaseType"
                />
            </van-popup>
            <van-field 
                v-model="formData.trackContent"
                name="trackContent"
                rows="2"
                label="跟进信息"
                type="textarea"
                placeholder="请输入跟进信息"
                required
                :rules="[{ required: true, message: '请输入跟进信息' }]"
            />
            <van-field name="trackPic" label="附加图片">
                <template #input>
                    <van-uploader v-model="formData.trackPic" :after-read="afterRead" 
                    :max-count="20"
                    :before-delete="delUploadImg" accept="image/*,video/*">
                        <template #preview-cover="scope">
                            <div class="preview" v-if="['mp4', 'm2v', 'mkv', 'mov', '3gp'].includes(onFileSuffix(scope.url))">
                                <video :src="scope.url" controls></video>
                            </div>
                        </template>
                    </van-uploader>
                </template>
            </van-field>
            <van-field
                clickable
                readonly
                name="trackStatus"
                :value="trackStatus"
                label="跟进状态"
                placeholder="点击选择跟进状态"
                :required="false"
                :rules="[{ required: false, message: '请点击选择跟进状态' }]"
                @click="!formData.efficacyTrackId && (showTrackStatus = true)"
            />
            <van-popup v-model="showTrackStatus" round position="bottom">
                <van-picker
                    show-toolbar
                    :columns="trackStatusList"
                    @cancel="showTrackStatus = false"
                    @confirm="onConfirmTrackStatus"
                />
            </van-popup>
            <div v-if="formData.trackStatus == 2 || formData.trackStatus == 3">
                <van-field
                    clickable
                    readonly
                    name="trackTime"
                    :value="formData.trackTime"
                    :label="trackTimeLabel"
                    placeholder="点击选择时间"
                    :required="false"
                    :rules="[{ required: false, message: '请点击点击选择时间' }]"
                    @click="(StartTimeShowPicker = true) && (currentDate = new Date())"
                />
                <van-popup v-model="StartTimeShowPicker" position="bottom">
                    <van-datetime-picker
                        v-model="currentDate"
                        type="datetime"
                        title="选择时间"
                        :min-date="minDate"
                        :max-date="maxDate"
                        @confirm="onConfirmStartTime"
                        @cancel="StartTimeShowPicker = false"
                    />
                </van-popup>
            </div>
            <div v-if="formData.trackStatus == 3">
                <van-field
                    name="trackRemark"
                    v-model="formData.trackRemark"
                    label="停药原因"
                    placeholder="请输入停药原因"
                    :required="false"
                    :rules="[{ required: false, message: '请输入停药原因' }]"
                />
            </div>
            <van-field
                clickable
                readonly
                name="trackType"
                :value="trackType"
                label="跟进方式"
                placeholder="点击选择跟进方式"
                :required="false"
                :rules="[{ required: false, message: '请点击选择跟进方式' }]"
                @click="showTrackType = true"
            />
            <van-popup v-model="showTrackType" round position="bottom">
                <van-picker
                    show-toolbar
                    :columns="trackTypeList"
                    @cancel="showTrackType = false"
                    @confirm="onConfirmTrackType"
                />
            </van-popup>
            <van-field
                clickable
                readonly
                name="nextTrackTime"
                :value="formData.nextTrackTime"
                label="下次跟进"
                placeholder="点击选择下次跟进时间"
                @click="(showNextTrackTime = true) && (currentDate = new Date())"
            />
            <van-popup v-model="showNextTrackTime" position="bottom">
                <van-datetime-picker
                    v-model="currentDate"
                    type="datetime"
                    title="选择下次跟进时间"
                    :min-date="minDate"
                    :max-date="maxDate"
                    @confirm="onConfirmNextTrackTime"
                    @cancel="showNextTrackTime = false"
                />
            </van-popup>
            <div class="submit">
                <van-button type="info" size="small" native-type="submit">保 存</van-button>
            </div>
        </van-form>
    </div>
</template>
<script>
import { parseTime } from '../../../utils/index'
    import { uploadOther, getDiseaseType } from '../../../api/index'
    export default {
        props: {
            formData: {
                type: Object
            }
        },
        data() {
            return {
                currentDate: '',
                // 疾病病种
                diseaseType: '',
                diseaseTypeList: [
                    // { text: '疑难杂症', value: 0 },
                    // { text: '胃病', value: 1 },
                    // { text: '消化系统', value: 2 },
                    // { text: '心脑血管', value: 3 },
                    // { text: '精神情志', value: 4 },
                    // { text: '肾脏系统', value: 5 },
                    // { text: '睡眠障碍', value: 6 },
                    // { text: '神经系统', value: 7 },
                    // { text: '男科', value: 8 },
                    // { text: '妇科', value: 9 },
                ],
                showDiseaseType: false,
                // 跟进时间
                trackTimeLabel: '开始时间',
                minDate: new Date(),
                maxDate: new Date(new Date().getFullYear() + 3, 11, 1),
                StartTimeShowPicker: false,
                // 跟进状态
                trackStatus: '',
                trackStatusList: [
                    { text: '仅咨询', value: 0 },
                    { text: '未服药', value: 1 },
                    { text: '服药中', value: 2 },
                    { text: '已停药', value: 3 },
                    { text: '服药未回应', value: 4 },
                ],
                showTrackStatus: false,
                // 跟进方式
                trackType: '',
                trackTypeList: [
                    { text: '短信', value: 0 },
                    { text: '微信', value: 1 },
                    { text: '电话', value: 2 },
                    { text: '面诊', value: 3 },
                ],
                showTrackType: false,
                // 下次跟进时间
                showNextTrackTime: false
            }
        },
        created() {
            getDiseaseType().then(({ data }) => { // 获取病种
                this.diseaseTypeList = (data.list || []).map((item) => ({text: item.value, value: item.key}));
                this.currentDate = new Date()
                this.diseaseTypeList.forEach(item => {
                    if(this.formData.diseaseType === item.value){
                        this.diseaseType = item.text
                    }
                })
                this.trackStatusList.forEach(item => {
                    if(this.formData.trackStatus === item.value){
                        this.trackStatus = item.text
                    }
                })
                this.trackTypeList.forEach(item => {
                    if(this.formData.trackType === item.value){
                        this.trackType = item.text
                    }
                })
            })
        },
        methods: {
            // 选择疾病病种
            onConfirmDiseaseType(val) {
                this.formData.diseaseType = val.value
                this.diseaseType = val.text
                this.showDiseaseType = false
            },
            // 选择跟进时间
            onConfirmStartTime(val) {
                console.log(parseTime(val))
                this.formData.trackTime = parseTime(val)
                this.StartTimeShowPicker = false
            },
            // 选择跟进状态
            onConfirmTrackStatus(val) {
                this.formData.trackStatus = val.value
                this.trackStatus = val.text
                if(val.value == 2){
                    this.trackTimeLabel = '开始服药'
                }else if(val.value == 3){
                    this.trackTimeLabel = '停药时间'
                }else {
                    this.formData.trackTime = ''
                }
                this.showTrackStatus = false
            },
            // 跟进状态
            onConfirmTrackType(val) {
                this.formData.trackType = val.value
                this.trackType = val.text
                this.showTrackType = false
            },
            // 下次跟进时间
            onConfirmNextTrackTime(val){
                this.formData.nextTrackTime = parseTime(val)
                this.showNextTrackTime = false
            },
            // 上传图片
            afterRead(file) {
                file.status = 'uploading';
                file.message = '上传中...';
                let formData = new FormData()
                formData.append('file',file.file)
                formData.append('module','efficacy')
                formData.append('category','track')
                uploadOther(formData).then(res => {
                    if(res.code == 0){
                        setTimeout(() => {
                            file.status = 'success';
                            file.message = ''
                            file.url = res.data.absoluteUrl
                        }, 300)
                    }
                }).catch((err) => {
                    file.status = 'failed';
                    file.message = '上传失败';
                });
            },
            // 删除图片
            delUploadImg(item) {
                this.formData.trackPic = this.formData.trackPic.filter(v => v.url != item.url)
                console.log(this.formData.trackPic)
            },
            // 提交
            onSubmit(values) {
                // console.log(this.formData)
                // console.log('submit', values);
                this.$emit('efficacyTrackSave', this.formData)
            },
            onFileSuffix(url) { // 文件后缀
                return url.substring(url.lastIndexOf('.') + 1)
            }
        }
    }
</script>
<style lang="scss" scoped>
.write {
    .submit {
        padding: 30px;
        display: flex;
        justify-content: center;
        .van-button {
            font-size: 14px;
            width: 82px;
            height: 34px;
        }
    }
    .van-field {
        font-size: 14px;
    }
    :deep(.van-image) {
        width: 120px;
        height: 120px;
    }
    :deep(.van-uploader__upload) {
        width: 120px;
        height: 120px;
    }
    :deep(.van-uploader__file) {
        width: 120px;
        height: 120px;
    }
}
.preview {
    width: 100%;
    height: 100%;
    background: #fff;
    video {
        width: 100%;
        height: 100%;
    }
}
</style>